import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService } from '../services/api.service';
import { LocalStorageService } from '../services/localstorage.service';
import { IAuth, IAuthErrors, IAuthToken } from '../interfaces';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [],
  providers: [ApiService, LocalStorageService]
})
export class LoginComponent implements OnInit {

  public code: String = '';
  public errors: any = {};
  public azureUrl: String = 'https://login.microsoftonline.com/98731832-40da-4546-9203-f68390800051/oauth2/authorize?client_id=93a8f098-16d0-42c8-bdde-c4bf85289c23&response_type=code&redirect_uri=https://admin.infochantiers.vingtcinq.io&response_mode=fragment';

  constructor(
    private _api: ApiService,
    private _storage: LocalStorageService,
    private _router: Router,
    private _route: ActivatedRoute,

  ) { }

  ngOnInit() {
    this._route.fragment.subscribe((fragment: string) => {
      if (fragment) {
        const params = fragment.split('&').reduce(function (q, query) {
          const chunks = query.split('=');
          const key = chunks[0];
          const value = chunks[1];
          return (q[key] = value, q);
        }, {});
        if ('code' in params) {
          this.code = params['code'];
          this.login();
        }
      }
    });
  }

  login() {
    this.errors = {};
    this._api.login
      .create({
        code: this.code
      })
      .subscribe(
        (data: IAuthToken) => {
          this._storage.set('token', data.key);
          this._api.me
            .list()
            .subscribe(
              (data_me) => {
                this._storage.setObject('user', data_me);
                this._router.navigate(['home']);
              },
              (errors) => {
                console.log(errors);
              });
        },
        (errors: any) => {
          this.errors = errors;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts